import {
    IDialogAction,
    IDialogStates,
    DIALOG_ACTION_TYPE,
    IUplevelDepartment,
    ISelectedMap,
    IExcludeMap,
} from './dialogContext';
import update from 'immutability-helper';
import { IListItem } from '@umu/umu-types';
import { onAllowPermissionSwitch } from './utils';

// 注释掉以下函数，因为:
// 1. 直接修改对象违反了React的不可变性原则
// 2. 会导致React无法正确检测状态变化，引起渲染问题
// 3. 没有参数类型检查，不符合TypeScript安全实践
// 4. 违反了reducer模式，应该返回新状态而非修改原状态
// const cleanObj = (obj: any) => {
//     Object.keys(obj).forEach((e: any) => {
//         delete obj[e];
//     });
// };

export function DialogReducer(state: IDialogStates, action: IDialogAction): IDialogStates {
    let newState = state;
    const selectedMap = state.selectedMap;
    const excludeMap = state.excludeMap;
    const dataList = state.dataList;
    const pageInfo = state.pageInfo;
    switch (action.type) {
        case DIALOG_ACTION_TYPE.SET_DEFAULT_SELECTED_LIST:
            const { defaultSelectedList, defaultExcludeList } = action.payload;
            // 不再使用cleanObj直接修改对象
            // cleanObj(selectedMap);
            // cleanObj(excludeMap);
            // 创建新的对象，而不是修改原有对象
            const newSelectedMap: ISelectedMap = {};
            const newExcludeMap: IExcludeMap = {};
            defaultSelectedList.forEach((i: any) => {
                if (i) {
                    newSelectedMap[i] = {} as IListItem;
                }
            });
            defaultExcludeList.forEach((i: string) => {
                if (i) {
                    newExcludeMap[i] = i;
                }
            });
            // console.log('selectedMap', selectedMap);
            newState = update(state, {
                // $merge: initState,
                excludeMap: {
                    $set: newExcludeMap,
                },
                selectedMap: {
                    $set: newSelectedMap,
                },
            });
            return newState;
        case DIALOG_ACTION_TYPE.UPDATE_SELECTED_MAP:
            const { list: _list } = action.payload;
            const _selectedMap: { [key: string]: IListItem } = {};

            _list.forEach((item: IListItem) => {
                _selectedMap[item.id] = item;
            });

            newState = update(state, {
                selectedMap: {
                    $set: _selectedMap,
                },
            });

            return newState;
        case DIALOG_ACTION_TYPE.SET_DEFAULT_SELECTED_DATAINFO:
            const { info } = action.payload;
            selectedMap[info.id] = info;

            newState = update(state, {
                selectedMap: {
                    $set: { ...selectedMap },
                },
            });

            return newState;
        case DIALOG_ACTION_TYPE.CLEAN:
            // 不再使用cleanObj直接修改对象
            // cleanObj(selectedMap);
            newState = update(state, {
                // $merge: initState,
                selectedMap: {
                    $set: {}, // 直接设置为新的空对象，符合不可变性原则
                },
                dataList: {
                    $set: dataList.map((data: IListItem) => ({ ...data, isSelected: false })),
                },
            });
            // console.log('DIALOG_ACTION_TYPE.CLEAN', selectedMap, newState);
            return newState;
        case DIALOG_ACTION_TYPE.SET_DATALIST:
            const { isMore, list, currDepartmentId, pInfo } = action.payload;
            const retList: IListItem[] = [];
            const pInfoTemp = {
                count: (pInfo && pInfo.count) || pageInfo.count,
                currentPage: (pInfo && pInfo.currentPage) || pageInfo.currentPage,
                totalPage: (pInfo && pInfo.totalPage) || pageInfo.totalPage,
                size: (pInfo && pInfo.size) || pageInfo.size,
            };
            list.forEach((data: IListItem) => {
                data.isSelected = data.isSelected || !!selectedMap[data.id];
                if (data.isSelected) {
                    // 校准一些缓存信息, 如初始化的时候只有id，没有其他信息
                    selectedMap[data.id] = data;
                }
                if (!excludeMap[data.id]) {
                    retList.push(data);
                }
            });
            newState = update(state, {
                dataList: {
                    $set: isMore ? dataList.concat(retList) : retList,
                },
                currDepartmentId: {
                    $set: currDepartmentId,
                },
                isSearchMode: {
                    $set: false,
                },
                pageInfo: {
                    $set: pInfoTemp,
                },
                ts: {
                    $set: Date.now(),
                },
            });
            return newState;
        case DIALOG_ACTION_TYPE.SET_ALL_LIST_CHECKED:
            const { isChecked } = action.payload;

            dataList.forEach((data) => {
                const isDisabledCheck = onAllowPermissionSwitch(data.oriData, state.hasAllPermissionRoles);
                data.isSelected = isDisabledCheck ? false : isChecked;
                isChecked && !isDisabledCheck ? (selectedMap[data.id] = data) : delete selectedMap[data.id];
            });
            newState = update(state, {
                dataList: {
                    $set: [...dataList],
                },
            });
            return newState;
        case DIALOG_ACTION_TYPE.SET_DATAITEM:
            const { item, isAdd, isRadio } = action.payload;
            if (isRadio) {
                Object.keys(selectedMap).forEach((key) => delete selectedMap[key]);
            }
            !!isAdd ? (selectedMap[item.id] = item) : delete selectedMap[item.id];
            dataList.forEach((data) => {
                if (data.id === item.id) {
                    data.isSelected = !!isAdd;
                } else {
                    if (isRadio) {
                        data.isSelected = false;
                        if (selectedMap[data.id]) {
                            delete selectedMap[data.id];
                        }
                    }
                    data.isSelected = data.isSelected || !!selectedMap[data.id];
                }
            });
            newState = update(state, {
                dataList: {
                    $set: [...dataList],
                },
                selectedMap: {
                    $set: selectedMap,
                },
                ts: {
                    $set: Date.now(),
                },
            });
            // console.log('DialogReducer SET_DATAITEM', isRadio, state, newState);
            return newState;
        case DIALOG_ACTION_TYPE.SET_DATASUG:
            const sug = action.payload.list;
            sug.forEach((data: any) => (data.isSelected = data.isSelected || !!selectedMap[data.id]));
            newState = update(state, {
                dataList: {
                    $set: sug,
                },
                isSearchMode: {
                    $set: action.payload.isSearchMode,
                },
                ts: {
                    $set: Date.now(),
                },
            });
            // console.log('DialogReducer SET_DATASUG', isRadio, state, newState);
            return newState;
        case DIALOG_ACTION_TYPE.SET_CACHE:
            const enterpriseName = action.payload.enterpriseName || state.enterpriseName;
            const departmentCache = action.payload.departmentCache || state.departmentCache;
            newState = update(state, {
                departmentCache: {
                    $set: departmentCache,
                },
                enterpriseName: {
                    $set: enterpriseName,
                },
            });
            // console.log('DialogReducer SET_CACHE', state, newState);
            return newState;
        case DIALOG_ACTION_TYPE.SET_UPLEVEL_DEPARTMENT:
            const uplevelDepartmentList = action.payload.uplevelDepartmentList || [];
            const uplevelIdMap = action.payload.uplevelIdMap || {};
            const uplevelDepartment: IUplevelDepartment = {};
            uplevelDepartmentList.forEach((i: IListItem) => {
                if (!uplevelDepartment[i.id]) {
                    uplevelDepartment[i.id] = i;
                }
            });
            // console.log('uplevelDepartment', uplevelDepartment, uplevelIdMap);
            newState = update(state, {
                uplevelDepartment: {
                    $set: uplevelDepartment,
                },
                uplevelIdMap: {
                    $set: uplevelIdMap,
                },
            });
            return newState;
        default:
            newState = state;
    }
    return newState;
}
